import { MeasurementEndContainer } from '../containers/MeasurementEndContainer/index'

export const MeasurementEndPage = () => (
    <MeasurementEndContainer/>
)